import { gql } from '@apollo/client';

export const COMFIRM_SETI_FOR_PAYMENT_CHANGE = gql`
  mutation wChangePMConfirm($uid: UUID!, $payment: Object!) {
    wChangePMConfirm(uid: $uid, payment: $payment)
  }
`;
